import {
  DashboardIcon,
  CompositionsIcon,
  PermissionsIcon,
  PluginIcon,
  SettingsIcon
} from '../assets/icons/icons';

export const navigationConfig = [
  {
    id: 'dashboard',
    path: '/dashboard',
    label: 'Dashboard',
    icon: DashboardIcon
  },
  {
    id: 'compositions',
    path: '/compositions',
    label: 'Compositions',
    icon: CompositionsIcon
  },
  {
    id: 'permissions',
    path: '/permissions',
    label: 'Permissions',
    icon: PermissionsIcon
  },
  {
    id: 'plugins',
    path: '/plugins',
    label: 'Plugins',
    icon: PluginIcon
  },
  {
    id: 'settings',
    path: '/settings',
    label: 'Settings',
    icon: SettingsIcon
  },
];
